<template>
  <div v-if="getOptions" class="container-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames">
        <el-collapse-item title="背景设置" name="1">
          <cx-background :background.sync="background" imgType="11" :showVideo="true" />
        </el-collapse-item>
        <el-collapse-item v-show="stageType === 'layOut'" title="排列" name="2">
          <slider-and-input :value.sync="rowLen" title="行数" :sliderMin="1" :sliderMax="20" suffix="行" />
          <slider-and-input class="mt16" :value.sync="colLen" title="列数" :sliderMin="1" :sliderMax="20" suffix="列" />
          <el-button style="width: 100%; font-size: 14px" class="mt16" size="small" type="primary" @click="addTable"
            >生成布局</el-button
          >
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import {
  getAttrById,
  handleFindLayoutStageOptionsByContainerId,
  getAllColsUidInLayoutComponent,
  handleFindLayoutComponentOptionsCols
} from "../../../utils"
import defaultBgImage from "../../../assets/images/default_image.png"
import { v1 } from "uuid"
const uuid = { v1 }
import { primaryBigScreenGenerator as primarybigScreenGenerator } from "@/store/modules/bigScreen/state"
import { primaryStageGenerator as primarystageGenerator } from "@/store/modules/stage/state"
import { primaryAppStageGenerator as primaryappStageGenerator } from "@/store/modules/appStage/state"
const mockData = { primarybigScreenGenerator, primaryappStageGenerator, primarystageGenerator }
export default {
  name: "bigScreen-container-options-setting",
  data() {
    return {
      rowLen: 1,
      colLen: 1,
      activeNames: ["1", "2"],
      defaultBgImage: defaultBgImage,
      this1: this,
      activeType: 1,
      checked: true,
      borderTypeFlag: 1,
      borderRadiusChecked: true,
      tabsActive: 0, //  显示背景还是背景图片
      pageSizeList: [
        {
          type: 1,
          width: 1920,
          height: 1080,
          proportion: "16:9"
        },
        {
          type: 2,
          width: 1920,
          height: 1440,
          proportion: "4:3"
        },
        {
          type: 3,
          width: 1080,
          height: 1920,
          proportion: "9:16"
        },
        {
          type: 4,
          proportion: "自定义"
        }
      ],
      sizeTypeObj: {
        type: 4,
        proportion: "自定义"
      }
    }
  },
  watch: {
    width(newVal, oldVal) {
      if (this.sizeTypeObj.type !== 4) {
        this.height = parseInt((newVal * this.sizeTypeObj.height) / this.sizeTypeObj.width)
      }
    },
    height(newVal, oldVal) {
      if (this.sizeTypeObj.type !== 4) {
        this.width = parseInt((newVal * this.sizeTypeObj.width) / this.sizeTypeObj.height)
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    stageType() {
      return this.$store.state[this.request_prefix].page.stageType
    },
    activeRect() {
      // this.getOptions();
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    background: {
      get() {
        let background = this.getOptions.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.getOptions.background
        }
        let newBackground = []
        if (this.backgroundImage) {
          newBackground.push({
            type: "img",
            label: "图片",
            imgUrl: this.backgroundImage,
            clipSize: this.clipSize,
            repeatType: this.repeatType,
            alignType: this.alignType,
            opacity: 100
          })
        }
        if (this.bgColorType === "线性渐变") {
          newBackground.push({
            type: "linearGradient",
            label: "线性渐变",
            data: {
              angle: this.bgColorlinearGradientAngle,
              stops: [
                [this.bgStartColor, 0],
                [this.bgEndColor, 1]
              ]
            }
          })
        }
        if (this.bgColorType === "径向渐变") {
          newBackground.push({
            type: "radialGradient",
            label: "径向渐变",
            data: {
              siteX: 50,
              siteY: 50,
              stops: [
                [this.bgStartColor, 0],
                [this.bgEndColor, 1]
              ]
            }
          })
        }
        newBackground.push({
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: this.bgColorType === "纯色" ? this.bgColor : "rgba(0,0,0,0)"
        })
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    sizeType: {
      get() {
        let sizeType = this.getOptions.sizeType || 1
        for (let i = 0; i < this.pageSizeList.length; i++) {
          if (this.pageSizeList[i].sizeType == sizeType) {
            this.sizeTypeObj = this.pageSizeList[i]
            break
          }
        }
        return this.getOptions.sizeType || 4
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "sizeType", false)
      }
    },
    width: {
      get() {
        return getAttrById(this.$store.state[this.request_prefix], { container_id: this.ids.container_id }).width
      },
      set(newVal) {
        this.$store.dispatch(this.request_prefix + "/changeContainerAttribute", {
          key: "width",
          data: newVal,
          containerId: this.ids.container_id
        })
      }
    },
    height: {
      get() {
        return getAttrById(this.$store.state[this.request_prefix], { container_id: this.ids.container_id }).height
      },
      set(newVal) {
        this.$store.dispatch(this.request_prefix + "/changeContainerAttribute", {
          key: "height",
          data: newVal,
          containerId: this.ids.container_id
        })
      }
    },
    backgroundImage: {
      get() {
        return this.getOptions.imgSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "imgSrc", false)
      }
    },
    clipSize: {
      get() {
        return this.getOptions.hasOwnProperty("clipSize") ? this.getOptions.clipSize : "auto auto"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "clipSize", false)
      }
    },
    repeatType: {
      get() {
        return this.getOptions.hasOwnProperty("repeatType") ? this.getOptions.repeatType : "no-repeat"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "repeatType", false)
      }
    },
    alignType: {
      get() {
        return this.getOptions.hasOwnProperty("alignType") ? this.getOptions.alignType : "left top"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "alignType", false)
      }
    },
    opacity: {
      get() {
        return this.getOptions.hasOwnProperty("opacity") ? this.getOptions.opacity : 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    openBgSet: {
      get() {
        return this.getOptions.openBgSet || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "openBgSet", false)
      }
    },
    bgColor: {
      get() {
        return this.getOptions.bgColor || "#00043A"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    },
    bgColorlinearGradientAngle: {
      get() {
        return this.getOptions.bgColorlinearGradientAngle || 90
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "bgColorlinearGradientAngle", false)
      }
    },
    bgColorType: {
      get() {
        return this.getOptions.bgColorType || "纯色"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColorType", false)
      }
    },
    bgStartColor: {
      get() {
        return this.getOptions.bgStartColor || "#07153C"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgStartColor", false)
      }
    },
    bgEndColor: {
      get() {
        return this.getOptions.bgEndColor || "#2581DC"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgEndColor", false)
      }
    },
    getOptions() {
      return this.$getOptions({ container_id: this.ids.container_id })
    }
  },
  methods: {
    addTable() {
      if (this.rowLen < 2 && this.colLen < 2) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "warning",
          message: "行或列的数量必须均大于一"
        })
        return
      }
      const _table = this.initTable(this.colLen, this.rowLen) //初始化所需新增的table
      this.initContainerByTable(_table) //根据table内的空col数量，新增对应的画布，并且进行画布绑定
      const find = {}
      const opt = this.$store.state[this.request_prefix].page.layoutOption.rows
      handleFindLayoutStageOptionsByContainerId(opt, this.ids.container_id, find)
      const _col = find.data[find.index]
      this.$store.dispatch(this.request_prefix + "/deleteContainer", _col.container_id)
      this.$store.dispatch(this.request_prefix + "/changeStageLayoutOption", {
        key: "container_id",
        uid: _col.uid,
        type: "del"
      })
      if (opt.length === 1 && opt[0].cols.length === 1) {
        console.log("none")
        //一行一列的特殊布局 直接覆盖 不用做更新
        this.$store.dispatch(this.request_prefix + "/changeStageLayoutOption", {
          key: "rows",
          value: _table
        })
      } else {
        this.$store.dispatch(this.request_prefix + "/changeStageLayoutOption", {
          key: "rows",
          uid: _col.uid,
          value: _table
        })
      }
      this.rowLen = 0
      this.colLen = 0
    },
    initContainerByTable(rowTable) {
      const allUid = getAllColsUidInLayoutComponent(rowTable) //获取所有的最底层cols
      allUid.forEach(uid => {
        const stageOpt = {
          options: {
            background: {
              0: { color: this.request_prefix.includes("bigScreen") ? "rgb(0, 4, 58)" : "rgba(255,255,255,1)" }
            }
          }
        }
        const param = {
          container_data: new mockData["primary" + this.request_prefix + "Generator"](stageOpt)
        }
        this.$store.dispatch(this.request_prefix + "/insertContainer", JSON.parse(JSON.stringify(param)))
        const stages = this.$store.state[this.request_prefix].page.children
        handleFindLayoutComponentOptionsCols(rowTable, uid).container_id = stages[stages.length - 1].container_id
      })
    },
    initTable(colLen, rowLen) {
      const _table = []
      class baseRow {
        constructor(params) {
          this.height = params.height
          this.uid = uuid.v1()
        }
      }
      class baseCol {
        constructor(params) {
          this.width = params.width
          this.uid = uuid.v1()
        }
      }
      const itemRowH = parseInt(100 / rowLen) + "%"
      const itemColW = parseInt(100 / colLen) + "%"
      for (let i = 0; i < rowLen; i++) {
        const tempRow = new baseRow({ height: itemRowH })
        console.log(colLen)
        tempRow.cols = new Array(colLen).fill(1).map(item => {
          return new baseCol({ width: itemColW })
        })
        _table.push(tempRow)
      }
      return _table
    },
    // 切换当前tab激活项
    changeActiveHandle(event, flag) {
      event.stopPropagation()
      this.tabsActive = flag
    },
    switchHandle(type) {
      this.activeType = type
    },
    changeBorderRadiusType(value) {
      this.borderTypeFlag = value
    },
    handleCommand(command) {
      this.sizeTypeObj = this.pageSizeList[command]
      this.sizeType = this.sizeTypeObj.type
      if (this.sizeTypeObj.type !== 4) {
        //自定义尺寸
        this.width = this.sizeTypeObj.width
        this.height = this.sizeTypeObj.height
      }
    }
  }
}
</script>

<style scoped>
.width_100 {
  width: 100%;
}
.repeat-style-ul > li {
  margin-right: 20px;
  margin-bottom: 16px;
}
.el-radio-group label {
  margin-bottom: 16px;
}
.common_btn_28_20 {
  padding: 5px 10px;
}
/*.color-picker-container {*/
/*  width: auto;*/
/*}*/
.edit-size-list {
  width: 252px;
  /*background: var(--themeColor);*/
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.edit-size-list-dropdown {
  width: calc(100% - 70px);
}
.el-dropdown-menu__item.active,
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: #35383f;
  color: #66b1ff;
}
::v-deep.content-item .el-radio__label {
  margin-left: 0;
}
.color-picker-container.custom-container-bg {
  width: calc(100% - 80px);
  display: inline-block;
  vertical-align: middle;
}
.bg-tabs .tabs-item {
  font-weight: 600;
  font-size: 14px;
  line-height: 44px;
  text-align: center;
  color: var(--subTextColor);
  margin-right: 24px;
}
.bg-tabs .tabs-item.active {
  color: var(--themeColor);
  border-bottom: 2px solid;
}
.paddingl0 {
  padding-left: 0;
}
</style>
